import { KeyLabelType, Nullable, TableDataType } from '~/types';
import apiClient from '../../api/http-common';
import { AxiosResponse } from 'axios';

const getMilkFixedPriceList = (data?): ApiClientReturnType<TradingSlotListType[]> =>
  apiClient.post('/trading-slots/list', data)

const getFatProteinSlotsList = (data?): ApiClientReturnType<TradingSlotListType[]> =>
  apiClient.post('/fat-protein/trading-slots/list', data)

const getStockExchangeSlotsList = (data?): ApiClientReturnType<TradingSlotListType[]> =>
  apiClient.post('/stock-exchange/trading-slots/list', data)

const getMilkFixedPriceIndex = (data: TableFilteredType): ApiClientReturnType<MilkFixedPriceDataType> =>
  apiClient.post('/trading-slots/index', data)

const getMilkFixedPriceIndexData = (): ApiClientReturnType<MilkFixedOptions[]> =>
  apiClient.post('/trading-slots/get-index-data')

const countActiveTradingSlots = (): ApiClientReturnType<number> =>
  apiClient.post('/trading-slots/count-active')

const getMilkFixedPriceOptions = (): ApiClientReturnType<MilkFixedCreateOptionsType> =>
  apiClient.post('/trading-slots/get-options-data')

const countTradingSlots = (data: TableFilteredType): ApiClientReturnType<CountTypes[]> =>
  apiClient.post('/trading-slots/count', data)

const createTradingSlot = (data: TradingSlotType): ApiClientReturnType<void> =>
  apiClient.post('/trading-slots/store', data)

const editTradingSlot = (id: string): ApiClientReturnType<TradingSlotType> =>
  apiClient.post(`/trading-slots/${id}/edit`)

const getFileTradingSlot = (id: string, data: GetFileType): ApiClientReturnType<string> =>
  apiClient.post(`/trading-slots/${id}/get-file`, data)

const deleteFileTradingSlot = (id: string, data: GetFileType): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/delete-file`, data)

const farmersTradingSlot = (id: string, data: FarmerTradingSlotFilterType): ApiClientReturnType<FarmersTradingType> =>
  apiClient.post(`/trading-slots/${id}/farmers`, data)

const updateTradingSlot = (id: string, data: TradingSlotType): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/update`, data)

// Show Trading slot

const showTradingSlot = (id: string): ApiClientReturnType<ShowType> =>
  apiClient.post(`/trading-slots/${id}/show`)

const showTradingSlotFarmerData = (id: string, idFarmer: string): ApiClientReturnType<FarmerGroupShowType> =>
  apiClient.post(`/trading-slots/${id}/farmer-groups/${idFarmer}/get-data`)

const showTradingSlotFarmerDataMonths = (id: string, idFarmer: string): ApiClientReturnType<TradingSlotMonthsType[]> =>
  apiClient.post(`/trading-slots/${id}/farmer-groups/${idFarmer}/trading-months`)

const updateShowTradingSlotFarmerDataMonths = (id: string, idFarmer: string, data: { tradingMonths: TradingSlotMonthsType[] }): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/farmer-groups/${idFarmer}/trading-months/update`, data)

const planTradingSlot = (id: string, data: Nullable<{ code: string }>): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/plan`, data)

const notifyFarmersTradingSlot = (id: string, data: { farmerGroups: string[] }): ApiClientReturnType<number> =>
  apiClient.post(`/trading-slots/${id}/notify/get-recipients`, data)

const notifyFarmers = (id: string, data: { farmerGroups: string[] }): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/notify`, data)

const abortTradingSlot = (id: string, data?: Nullable<{ code: string }>): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/abort`, data)

const getFile = (id: string, idFarmer: string, data: { fileName: string }): ApiClientReturnType<string> =>
  apiClient.post(`/trading-slots/${id}/farmer-groups/${idFarmer}/get-file`, data)

// Offers Preview Trading slot

const offersPreviewTradingSlot = (id: string, data: Nullable<{ farmerGroupId: string }>): ApiClientReturnType<OfferPreviewType[]> =>
  apiClient.post(`/trading-slots/${id}/offers-preview`, data)

const saveOffersPreviewTradingSlot = (id: string, data: ConfirmOfferType): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/confirm-offers/save`, data)

const confirmOffersPreviewTradingSlot = (id: string, data: Nullable<{ code: string }>): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/confirm-offers/confirm`, data)

const getOffersPreviewTradingSlot = (id: string, data: { date: Date, price: string }): ApiClientReturnType<ParticipiantType[]> =>
  apiClient.post(`/trading-slots/${id}/confirm-offers/get-offers`, data)

const offersPreviewTradingSlotOptions = (id: string): ApiClientReturnType<OffersOptionsType> =>
  apiClient.post(`/trading-slots/${id}/confirm-offers/get-settings-data`)

const offersPreviewTradingSlotByMonths = (id: string, farmerGroupId: string): ApiClientReturnType<OfferPreviewMonth[]> =>
  apiClient.post(`trading-slots/${id}/confirm-offers/get-months`, { farmerGroupId })

const deleteTradingOffer = (tradingSlotId: string, offerId: string): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${tradingSlotId}/confirm-offers/${offerId}/delete`)

// Farmer Offers Preview Trading slot Farmer
const farmerOfferAmountsSettings = (id: string): ApiClientReturnType<AmountSettingsType> =>
  apiClient.post(`/trading-slots/${id}/offer/get-settings-data`)

const getTradingSlotsFarmerSettings = (): ApiClientReturnType<TradingSlotSettingsType> =>
  apiClient.post('/trading-slots/get-settings-data')

const farmerOfferAmountsList = (id: string): ApiClientReturnType<AmountMonthType[]> =>
  apiClient.post(`/trading-slots/${id}/offer/get-months`)

const saveFarmerOfferAmountsList = (id: string, data: FarmerOfferType): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/offer/save`, data)

const getTradingActivities = (data: Nullable<Omit<TableFilteredType, 'search'>>): ApiClientReturnType<TradingActivitieType> =>
  apiClient.post('/trading-slots/offers/index', data)

const offersStatusOptions = (): ApiClientReturnType<KeyLabelType[]> =>
  apiClient.post('/trading-slots/offers/get-index-data')

const getPreviewOffers = (id: string, data?: Nullable<Omit<TableFilteredType, 'status' | 'search'>>): ApiClientReturnType<OfferResultsType> =>
  apiClient.post(`/trading-slots/${id}/offers/index`, data)

const abortTradingSlotOffer = (id: string, offerId: string, data?: Nullable<{ code: string }>): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/offers/${offerId}/abort`, data)

const abortTradingSlotOfferData = (id: string, offerId: string): ApiClientReturnType<AbortTradingType[]> =>
  apiClient.post(`/trading-slots/${id}/offers/${offerId}/get-abort-data`)

const getChangeAmountData = (id: string, offerId: string): ApiClientReturnType<ChangeAmountType> =>
  apiClient.post(`/trading-slots/${id}/offers/${offerId}/get-change-data`)

const changeAmountData = (id: string, offerId: string, data: { amount: number, code?: string }): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/offers/${offerId}/change`, data)

const getOffersData = (id: string, farmerGroupId: string, data: Omit<TableFilteredType, 'status'>): ApiClientReturnType<OfferGroupType> =>
  apiClient.post(`/trading-slots/${id}/farmer-groups/${farmerGroupId}/offers/index`, data)

const acceptTradingRooms = (id: string): ApiClientReturnType<void> =>
  apiClient.post(`/trading-slots/${id}/accept-trading-terms`)

const openTradingRoomFile = (data: { fileName: string }): ApiClientReturnType<string> =>
  apiClient.post('/trading-slots/get-trading-room-file', data)

const checkTradingRoomsAccept = (id: string): ApiClientReturnType<number> =>
  apiClient.post(`/trading-slots/${id}/terms-accepted`)

const MilkFixedService = {
  getMilkFixedPriceList,
  getMilkFixedPriceIndex,
  getMilkFixedPriceIndexData,
  getMilkFixedPriceOptions,
  createTradingSlot,
  showTradingSlot,
  countTradingSlots,
  showTradingSlotFarmerData,
  showTradingSlotFarmerDataMonths,
  offersPreviewTradingSlot,
  offersPreviewTradingSlotOptions,
  updateShowTradingSlotFarmerDataMonths,
  planTradingSlot,
  offersPreviewTradingSlotByMonths,
  farmerOfferAmountsSettings,
  farmerOfferAmountsList,
  saveFarmerOfferAmountsList,
  saveOffersPreviewTradingSlot,
  confirmOffersPreviewTradingSlot,
  getOffersPreviewTradingSlot,
  abortTradingSlot,
  editTradingSlot,
  updateTradingSlot,
  getTradingActivities,
  getPreviewOffers,
  farmersTradingSlot,
  notifyFarmersTradingSlot,
  notifyFarmers,
  offersStatusOptions,
  getTradingSlotsFarmerSettings,
  getFile,
  abortTradingSlotOffer,
  getChangeAmountData,
  changeAmountData,
  acceptTradingRooms,
  openTradingRoomFile,
  getFileTradingSlot,
  deleteFileTradingSlot,
  countActiveTradingSlots,
  deleteTradingOffer,
  abortTradingSlotOfferData,
  checkTradingRoomsAccept,
  getOffersData,
  getFatProteinSlotsList,
  getStockExchangeSlotsList
}

type MilkFixedPriceDataType = TableDataType<RowFixedPriceDataType>
export interface RowFixedPriceDataType {
  id: string;
  uniqueId: string;
  status: string;
  dateFrom: string;
  dateTo: string;
  totalFarmers: number;
  offeredFarmers: number;
  totalOffers: number;
  totalAmount: number;
  totalOfferedAmount: number;
  totalConfirmedAmount: number;
  tradingVolumeTypeId: string;
  statusLabel: string;
  tradingVolumeTypePercent: string;
  tradingVolumeTypeCode: string;
  tradingVolumeTypeIcon: string;
  tradingVolumeTypeName: string;
  tradingVolumeTypeLabel: string;
  tradingVolumeTypeTradingVolumeTypeId: string;
  tradingVolumeTypeLanguageId: number;
}

interface GetFileType {
  fileName: string
}

export interface AmountSettingsType {
  farmerId: string;
  id: string;
  amountOfferingType: 'monthly' | 'quarterly' | 'all';
  termsAccepted: number;
  statusLabel: string;
  amountOfferStep: number | null;
  minContingentOffer: number;
  exceedingMaxAllowed: number;
  hiddenPrices: number;
  useMinimumContingentSum: number;
  individualSubSupplierOffer: number;
  tradingRoom: number;
  farmerOfferChange: number;
  defaultAmountChangesNumber: number;
  showPricesInLiveStatus: number;
  minimumContingent: string;
  canChangeAmounts: boolean;
}

type FarmerAmountMonthType = {
  id: string;
  date: string;
  status: number;
  monthValue: number;
  deliveryDate: string | null;
  terminationDate: string | null;
  maxAmount: number;
  total?: string;
  offeredAmount: number;
  price: string;
  amount?: string;
}
export interface AmountMonthType extends FarmerAmountMonthType {
  farmers: FarmerAmountMonthType[]
}

type TermType = {
  id: string;
  status: number;
  code: string;
  icon: string;
  title: string;
  originalFilename: string;
  filename: string;
  label: string;
  tradingSlotTermId: string;
  languageId: number;
  visible: number;
}

type TermTextType = {
  slug: string;
  label: string;
  id: number;
  code: string;
  icon: string;
  translation: string;
  textId: number;
  languageId: number;
}

interface TermSettingsType {
  tradingRoom: number;
  terms: TermType[];
  texts: TermTextType[];
}
export interface TradingSlotSettingsType extends TermSettingsType {
  showPricesInLiveStatus: number;
  ifeSubmitPrices?: number;
}
interface MilkFixedOptions {
  key: string;
  label: string;
}
interface CountTypes {
  status: string;
  count: number;
  statusLabel: string;
}

interface MilkFixedCreateOptionsType {
  module: string;
  tradingSlotMethods: AmountOfferingType[];
  amountOfferingTypes: AmountOfferingType[];
  tradingVolumeTypes: TradingVolumeType[];
  languages: Language[];
}

interface AmountOfferingType {
  key: string;
  label: string;
}

interface Language {
  id: string;
  code: string;
  order: number;
  icon: string;
  label: string;
}

interface TradingVolumeType {
  id: string;
  percent: string;
  code: string;
  icon: string;
  name: string;
  label: string;
  tradingVolumeTypeId: string;
  languageId: number;
}
interface TradingSlotType {
  id: string;
  dateFrom: string;
  dateTo: string;
  confirmMethod: string;
  amountOfferingType: string;
  tradingVolumeTypeId: string;
  farmerGroups: string[];
  statusLabel: string;
  tradingVolumeTypePercent: string;
  tradingVolumeTypeCode: string;
  tradingVolumeTypeIcon: string;
  tradingVolumeTypeName: string;
  tradingVolumeTypeLabel: string;
  tradingVolumeTypeTradingVolumeTypeId: string;
  tradingVolumeTypeLanguageId: number;
  languages?: LanguageStoreData[];
}

interface LanguageStoreData {
  id: string;
  code?: string;
  icon?: string;
  order?: number;
  description: string;
  originalFilename?: string;
  filename?: string;
  label?: string;
  tradingSlotId?: string;
  languageId?: number;
}

type FarmersTradingType = TableDataType<FarmersRowTradingType>
interface FarmersRowTradingType {
  id: string;
  supplierNo: string;
  companyName: string;
  amount: number;
  tradingAmount: string;
  monthlyTradingAmount: string;
  tradingSlotId: string;
  farmerId: string;
  status: number;
  createdAt: string;
}
interface TradingSlotMonthsType {
  id: string;
  date: string;
  percent: string;
  status: number;
  monthlyTradingAmount: string;
  price: string;
  total: string;
  ifePrice: number;
}
interface ShowType {
  id: string;
  uniqueId: string;
  dateFrom: string;
  dateTo: string;
  status: string;
  confirmMethod: string;
  amountOfferingType: string;
  tradingVolumeTypeId: string;
  createdAt: string;
  ifePricesLastUpdate: null;
  farmerGroups: FarmerGroup[];
  showDefinedTradingSlots: number;
  statusLabel: string;
  tradingVolumeTypePercent: string;
  tradingVolumeTypeCode: string;
  tradingVolumeTypeIcon: string;
  tradingVolumeTypeName: string;
  tradingVolumeTypeLabel: string;
  tradingVolumeTypeTradingVolumeTypeId: string;
  tradingVolumeTypeLanguageId: number;
  code: string;
  icon: string;
  description: string;
  originalFilename: string;
  filename: string;
  label: string;
  tradingSlotId: string;
  languageId: number;
}
interface FarmerGroup {
  id: string;
  name: string;
  amountPercent: string;
}
interface TradingSlotListType {
  id: string;
  uniqueId: string;
  dateFrom: string;
  statusLabel: string;
}
interface TableFilteredType {
  page: number,
  rows: number,
  search: string,
  status: string
}

type FarmerTradingSlotFilterType = Omit<TableFilteredType, 'status'> | {
  farmerGroupId: string;
}

type ApiClientReturnType<T> = Promise<AxiosResponse<T>>;
interface FarmerGroupShowType {
  id: string;
  name: string;
  amountPercent: string;
  minimumContingent: number;
  ifePricesFile: null;
  farmersCount: number;
  tradingAmount: number;
  monthlyTradingAmount: number;
  offeredFarmersCount: number;
  offersCount: number;
  offeredAmount: string;
  confirmedAmount: string;
  statusLabel: string;
}
interface OfferPreviewType {
  date: string;
  price: string;
  offersCount: number;
  offeredAmount: string;
  confirmedAmount: string;
  total: string;
}
interface ConfirmOfferType {
  price: string;
  date: string;
  offeredAmount: string;
  confirmedAmount: string;
  total: string;
  amount: string;
  farmerGroupId?: null;
}
interface ParticipiantType {
  id: string;
  companyName: string;
  supplierNo: string;
  uniqueId: string;
  createdAt: string;
  status: string;
  amount: number;
  confirmedAmount: number;
  price: string;
  total: string;
  statusLabel: string;
}
interface OffersOptionsType {
  operativeUsersCanSeeFarmersInfo: number;
  farmerGroups: FarmerGroup[];
  months: Month[];
  confirmAvailable: boolean;
  offerDeleteAvailable: boolean;
}
interface Month {
  date: string;
  label: string;
}
interface OfferPreviewMonth {
  price: string;
  date: string;
  offeredAmount: string;
  confirmedAmount: string;
  total: string;
}
interface FarmerOfferType {
  amounts: Amount[];
  code: string;
  browserName: string;
  browserVersion: string;
  platformName: string;
}
interface Amount {
  id: string;
  amount: number;
  farmerId: string;
}

type TradingActivitieType = TableDataType<TradingActivitieRowType>
interface TradingActivitieRowType {
  id: string;
  uniqueId: string;
  createdAt: string;
  status: string;
  amount: number;
  confirmedAmount: number;
  tradingSlotId: string;
  tradingMonthId: string;
  price: string;
  date: string;
  tradingSlotUniqueId: string;
  confirmationDate: string;
  offerDeleteAvailable: number;
  statusLabel: string;
}

type OfferResultsType = TableDataType<OfferResultsRowType>

type OfferGroupType = TableDataType<Omit<OfferResultsRowType, 'timesChanged' | 'confirmationDate' | 'total'> & { companyName: string }>
interface OfferResultsRowType {
  id: string;
  date: string;
  supplierNo: string;
  uniqueId: string;
  createdAt: string;
  amount: number;
  confirmedAmount: number;
  status: string;
  price: string;
  timesChanged: number;
  confirmationDate: null;
  total: string;
  statusLabel: string;
}
interface AbortTradingType {
  date: string;
  price: string;
  companyName: string;
  supplierNo: string;
  uniqueId: string;
  amount: number;
  status: string;
  farmerId: string;
  batch: number;
  tradingMonthId: string;
  statusLabel: string;
}
interface ChangeAmountType {
  date: string;
  amount: number;
  minimumContingent: number;
  maxTradingAmount: number;
}

export default MilkFixedService
